import './ExportPageHeader.scss';

interface ExportPageHeaderProps {
  customerName: string
};

const ExportPageHeader = (props: ExportPageHeaderProps) => {
  return (
    <>
      <div className='export-header-content'>
        <div className='brand-wrapper'>
          <img src='/images/bywaters_logo.png' alt='bywaters_logo' />
          <div className='document-title'>BRAD Homepage Report</div>
        </div>
        <h3>{props.customerName}</h3>
      </div>
      <div className='separator' />
    </>
  );
};

export default ExportPageHeader;